// extracted by mini-css-extract-plugin
module.exports = {"order":"Order_order__1Xj04"};